import { render, staticRenderFns } from "./VoteResultStep.vue?vue&type=template&id=853f3d1e"
import script from "./VoteResultStep.vue?vue&type=script&lang=js"
export * from "./VoteResultStep.vue?vue&type=script&lang=js"
import style0 from "./VoteResultStep.vue?vue&type=style&index=0&id=853f3d1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports